import React from "react";
import { makeStyles, Grid, Button } from "@material-ui/core";
import IconTooltipButton from "../Buttons/IconTooltipButton";
import FilterList from "@material-ui/icons/FilterList";
import LanguageHelper from "../../helpers/LanguageHelper";

const useStyles = makeStyles((theme) => ({
  applyButton: {},
  clearButton: {},
  buttons: {
    marginTop: 30,
  },
}));

export function TableFiltersButtons({ tableRef, newTableFilters, setFilterProps, clearFilters }) {
  const classes = useStyles();
  const language = LanguageHelper.getLanguage();

  return (
    <Grid container className={classes.buttons}>
      <Grid item xs={3}>
        <Button
          variant="outlined"
          className={classes.clearButton}
          onClick={() => {
            clearFilters();
          }}
        >
          {language.tableFilters.cleanFilter}
        </Button>
      </Grid>
      <Grid item xs={6}>
        <Button
          variant="contained"
          color="primary"
          className={classes.applyButton}
          onClick={() => {
            setFilterProps(newTableFilters);
            tableRef.current && tableRef.current.onQueryChange();
          }}
        >
          {language.tableFilters.applyFilter}
        </Button>
      </Grid>
      <Grid item xs={3}></Grid>
    </Grid>
  );
}

export function TableFiltersOpenButton({ collapse, setCollapse, setFiltersOpen }) {
  const language = LanguageHelper.getLanguage();
  return (
    <IconTooltipButton
        title={language.tableFilters.showFilter}
        onClick={() => {
          setCollapse(!collapse);
          setTimeout(() => {
            setFiltersOpen(!collapse);
          }, 500);
        }}
      >
        <FilterList fontSize="large" />
    </IconTooltipButton>
  )
}
